import { onCLS, onINP, onFCP, onLCP, onTTFB, onFID } from "web-vitals";

const reportWebVitals = (onPerfEntry) => {
  if (!onPerfEntry || !(onPerfEntry instanceof Function)) {
    return;
  }

  onCLS(onPerfEntry);
  onINP(onPerfEntry);
  onFCP(onPerfEntry);
  onLCP(onPerfEntry);
  onTTFB(onPerfEntry);
  onFID(onPerfEntry);
};

export default reportWebVitals;
